import { useTranslation } from 'react-i18next';

import { useDepartments } from '../../queries';
import { Select } from '@/shared/ui/atoms/Select';

type Props = { id: string; value: string; onChange: (value: string) => void };

/** The organisation's departments; once any exists, members and projects must belong to one. */
export function DepartmentSelect({ id, value, onChange }: Props) {
  const { t } = useTranslation();
  const departments = useDepartments();
  return (
    <Select icon="office" id={id} value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="" disabled={(departments.data ?? []).length > 0}>
        {departments.isPending ? t('common.loading') : (departments.data ?? []).length === 0 ? t('departments.none') : t('departments.choose')}
      </option>
      {(departments.data ?? []).map((d) => (
        <option key={d.id} value={d.id}>
          {d.name}
        </option>
      ))}
    </Select>
  );
}
